import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';
import withWidth from '@material-ui/core/withWidth';

import { Field, getFormValues } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Layout from 'components/common/Layout';
import Progress from 'components/common/Progress';
import Filter from 'components/common/Filter';
import TextField from 'components/fields/TextField';
import TabNavigation from 'components/common/TabNavigation';
import PayersTable from 'components/settings/PayersTable';
import PayerCreateEditDialog from 'components/settings/PayerCreateEditDialog';
import FormControl from '@material-ui/core/FormControl';
import RadioButtonField from 'components/fields/RadioButtonField';
import RadioGroupField from 'components/fields/RadioGroupField';

import {
  fetchInsurances,
  clearInsurances,
  updateInsurancesData,
} from 'redux/modules/insurances';
import { fetchSystemSettings, updateSystemSettings } from 'redux/modules/systemSettings';

import { getFilterChangeTypes } from 'utils/filterChangeTypes';
import objectDiff from 'utils/objectDiff';
import throttle from 'utils/throttle';
import * as normalize from 'utils/normalize';
import * as validate from 'utils/validate';

import { appTitle, titleSeparator } from 'config/helmetSettings';

const styles = theme => ({
  gridItemActive: {
    [theme.breakpoints.down('sm')]: {
      flexBasis: '100%',
      maxWidth: '100%',
    },
  },
  paperActive: {
    marginLeft: 16,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      display: 'inline-flex',
    },
  },
});

class DataPortabilityInsurances extends Component {
  constructor(props) {
    super(props);

    this.state = {
      createDialogOpen: false,
      updatingInsuranceServices: false,
      mobileFilterExpanded: ['xs', 'sm'].indexOf(props.width) === -1,
      limit: 10,
      offset: 0,
    };

    this.onRequest = this.onRequest.bind(this);
    this.onFilterPrimaryButtonClick = this.onFilterPrimaryButtonClick.bind(this);
    this.onCreateDialogClose = this.onCreateDialogClose.bind(this);
    this.onUpdateInsuranceServicesButtonClick =
      this.onUpdateInsuranceServicesButtonClick.bind(this);
    this.onMobileFilterBottonClick = this.onMobileFilterBottonClick.bind(this);
    this.onTableScroll = this.onTableScroll.bind(this);

    this.onThrottledRequest = throttle(this.onRequest, 2000, false, true);
  }

  componentWillMount() {
    this.props.actions.clearInsurances();
  }

  componentDidMount() {
    this.onRequest();
    this.props.actions.fetchSystemSettings({ triggerLoading: true });
  }

  componentWillReceiveProps(nextProps) {
    const { filters, width } = this.props;
    const { limit, offset } = this.state;
    const filtersChanged = nextProps.filters['Payer Name'] !== filters['Payer Name']
      || nextProps.filters.Active !== filters.Active;
    let newOffset = offset;
    if (filtersChanged) {
      newOffset = 0;
    }

    if (newOffset !== offset) {
      this.setState({ offset: Math.max(newOffset, 0) });
    }

    if (nextProps.width !== width) {
      this.setState({
        mobileFilterExpanded: ['xs', 'sm'].indexOf(nextProps.width) === -1,
      });
    }

  }

  shouldComponentUpdate(nextProps, nextState) {
    return ((Object.keys(objectDiff(this.props, nextProps)).length +
      Object.keys(objectDiff(this.state, nextState)).length) > 0);
  }

  componentDidUpdate(prevProps, prevState) {
    const { filters, actions, systemSettings, insurances, count, loading } = this.props;
    const { limit, offset } = this.state;
    const limitChanged = prevState.limit !== limit;
    const offsetChanged = prevState.offset !== offset;
    const { throttledFiltersChanged, filtersChanged } = getFilterChangeTypes(
      prevProps.filters,
      filters,
      {
        textFilterKeys: ['Payer Name'],
        immediateFilterKeys: ['Active'],
      },
    );

    if (throttledFiltersChanged) {
      this.onThrottledRequest();
    } else if (limitChanged || offsetChanged || filtersChanged) {
      this.onRequest();
    } else if (insurances.length < count
      && this.scrollRef
      && this.scrollRef.scrollTop === 0
      && loading === 0) {
      this.onTableScroll({ target: this.scrollRef });
    }

    if (prevProps.filters['Profit Percent'] !== undefined
      && filters['Profit Percent'] !== ''
      && filters['Profit Percent'] !== undefined
      && prevProps.filters['Profit Percent'] !== filters['Profit Percent']) {
      actions.updateSystemSettings({
        values: {
          ...systemSettings,
          'System Config': {
            ...systemSettings['System Config'],
            PROFIT_PERCENT: Number(filters['Profit Percent'].replace('%', '')),
          },
        },
      });
    }
  }

  onRequest() {
    const { actions, filters } = this.props;
    const { limit, offset } = this.state;
    const requestFilters = filters && Object.keys(filters).length > 0
      ? Object.keys(filters).filter(key => key !== 'Profit Percent').map(key => ({
        name: key,
        ...key === 'Payer Name' && /^[\d]{4,10}$/i.test(filters[key]) ? { name: 'Trading Partner ID' } : {},
        operation: 'contains',
        ...key === 'Active' ? {
          name: 'Is Active',
          operation: 'eq',
        } : {
          case_sensitivity: false,
        },
        val: filters[key],
      }))
      : null;
    actions.fetchInsurances({
      limit,
      offset,
      filters: requestFilters,
      triggerLoading: true,
      push: offset > 0,
    });
  }

  onFilterPrimaryButtonClick() {
    this.setState({ createDialogOpen: true });
  }

  onCreateDialogClose() {
    this.setState({ createDialogOpen: false });
  }

  onUpdateInsuranceServicesButtonClick() {
    const { actions } = this.props;
    this.setState({ updatingInsuranceServices: true });
    actions.updateInsurancesData({
      resolve: () => {
        this.setState({ updatingInsuranceServices: false });
      },
      reject: () => {
        this.setState({ updatingInsuranceServices: false });
      },
    });
  }

  onMobileFilterBottonClick() {
    this.setState({ mobileFilterExpanded: !this.state.mobileFilterExpanded });
  }

  onTableScroll(event) {
    const { offset, limit } = this.state;
    if ((event.target.offsetHeight + event.target.scrollTop) / event.target.scrollHeight > 0.9) {
      if ((this.props.insurances.length - limit) >= offset) {
        this.setState({
          offset: offset + limit,
        });
      }
    }
  }

  render() {
    const {
      insurances,
      count,
      loading,
      settingsLoading,
      systemSettings,
      account,
      classes,
      filters,
    } = this.props;
    const {
      createDialogOpen,
      updatingInsuranceServices,
      mobileFilterExpanded,
    } = this.state;
    return (
      <Layout variant="settings">
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Data Portability {titleSeparator} Payers
          </title>
        </Helmet>
        <TabNavigation
          items={[
            {
              text: 'Referrals',
              href: '/settings/medical-sources/referrals',
            },
            {
              text: 'Sales',
              href: '/settings/medical-sources/sales',
            },
            {
              text: 'Prescribers',
              href: '/settings/medical-sources/prescribers',
            },
            {
              text: 'HCPCS Codes',
              href: '/settings/medical-sources/hcpc',
            },
            {
              text: 'Diagnosis',
              href: '/settings/medical-sources/diagnosis',
            },
            {
              text: 'Payers',
              href: '/settings/medical-sources/payers',
            },
          ]}
        />
        {settingsLoading === 0 &&
          <Filter
            form="insurancesFilter"
            placeholder="Search by Payer Name or Payer ID"
            primaryButtonText="Add New Payer"
            onPrimaryButtonClick={this.onFilterPrimaryButtonClick}
            secondaryButtonText="Update Payers"
            secondaryButtonLoading={updatingInsuranceServices}
            secondaryButtonDisabled={updatingInsuranceServices ||
              account.Roles.filter(item =>
                item.Name === 'Master Administrator' || item.Name === 'Administrator').length === 0}
            onSecondaryButtonClick={this.onUpdateInsuranceServicesButtonClick}
            onMobileFilterBottonClick={this.onMobileFilterBottonClick}
            mobileFilterExpanded={mobileFilterExpanded}
            filters={filters}
            showTableCount
            count={count}
            loading={loading}
            items={insurances}
            searchWidth={4}
            secondaryFilter={(
              <Grid item xs={12} md={8}>
                <Grid
                  container
                  alignItems="center"
                  spacing={8}
                >
                  <Grid item>
                    <Typography>
                      Increase Reimbursements by %:
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Paper
                      style={{
                        width: 82,
                      }}
                    >
                      <Field
                        id="Profit Percent"
                        name="Profit Percent"
                        component={TextField}
                        normalize={normalize.profitPercent}
                        validate={validate.required}
                        fullWidth
                        descriptionPlacement="bottom"
                        disabled={account.Roles.filter(item =>
                          item.Name === 'Master Administrator').length === 0}
                        description={`${account.Roles.filter(item =>
                          item.Name === 'Master Administrator').length === 0 ? 'Master Administrator Only. ' : ''}This Field sets a default percent increase of reimbursements for all payers.
                          The increase is based on current highest price between Medicare and Medicaid Fee Schedule.
                          However you can still set up individual profit percent increases for each payer.
                        `}
                      />
                    </Paper>
                  </Grid>
                  <Grid item className={classes.gridItemActive}>
                    <Paper className={classes.paperActive}>
                      <FormControl role="group">
                        <Field
                          name="Active"
                          component={RadioGroupField}
                        >
                          {['All', 'Active', 'Inactive'].map(item => (
                            <RadioButtonField
                              key={item}
                              value={item}
                              label={item}
                              color="primary"
                            />
                          ))}
                        </Field>
                      </FormControl>
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
            )}
            initialValues={{
              ...systemSettings['System Config'] && systemSettings['System Config'].PROFIT_PERCENT !== undefined ? {
                'Profit Percent': systemSettings['System Config'].PROFIT_PERCENT,
              } : {},
              Active: 'Active',
            }}
            beforeTable
          />
        }
        {loading > 0 && (
          <Progress fixed />
        )}
        <PayersTable
          items={insurances}
          count={count}
          loading={loading}
          mobileFilterExpanded={mobileFilterExpanded}
          onScroll={this.onTableScroll}
          scrollRef={(scrollRef) => { this.scrollRef = scrollRef; }}
        />
        <PayerCreateEditDialog
          form="payerCreate"
          open={createDialogOpen}
          onClose={this.onCreateDialogClose}
          onSubmitSuccess={() => {
            this.onCreateDialogClose();
            this.onRequest();
          }}
        />
      </Layout>
    );
  }
}

DataPortabilityInsurances.propTypes = {
  insurances: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })).isRequired,
  count: PropTypes.number.isRequired,
  loading: PropTypes.number.isRequired,
  settingsLoading: PropTypes.number.isRequired,
  filters: PropTypes.shape({
    'Payer Name': PropTypes.string,
  }).isRequired,
  actions: PropTypes.shape({
    fetchInsurances: PropTypes.func.isRequired,
    clearInsurances: PropTypes.func.isRequired,
    updateInsurancesData: PropTypes.func.isRequired,
    fetchSystemSettings: PropTypes.func.isRequired,
    updateSystemSettings: PropTypes.func.isRequired,
  }).isRequired,
  width: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  systemSettings: PropTypes.object.isRequired,
  classes: PropTypes.shape({
    paperActive: PropTypes.string.isRequired,
  }).isRequired,
};

DataPortabilityInsurances.defaultProps = {};

const mapStateToProps = (store) => {
  const insurancesFilterValues = getFormValues('insurancesFilter')(store);
  return {
    insurances: store.insurances.data,
    systemSettings: store.systemSettings.data,
    count: store.insurances.count,
    account: store.account,
    filters: {
      ...insurancesFilterValues
        && insurancesFilterValues.Filter
        ? { 'Payer Name': insurancesFilterValues.Filter }
        : {},
      ...insurancesFilterValues
        ? { 'Profit Percent': insurancesFilterValues['Profit Percent'] }
        : {},
      ...insurancesFilterValues
        && insurancesFilterValues.Active
        && insurancesFilterValues.Active !== 'All'
        ? { Active: insurancesFilterValues.Active === 'Active' }
        : {},
    },
    loading: store.insurances.loading,
    settingsLoading: store.systemSettings.loading,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchInsurances,
    clearInsurances,
    updateInsurancesData,
    fetchSystemSettings,
    updateSystemSettings,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(withWidth()(DataPortabilityInsurances)),
);



// WEBPACK FOOTER //
// ./src/pages/settings/DataPortabilityInsurances.js